/**
 * Notifications Package
 *
 * Push notification setup and management.
 */

export {
  usePushNotifications,
  getPushToken,
  type PushNotification,
  type UsePushNotificationsResult,
  type UsePushNotificationsOptions,
} from "./usePushNotifications";

export { useNotificationDeliverability } from "./NotificationDeliverabilityContext";
export type { NotificationDeliverabilityContextValue } from "./NotificationDeliverabilityContext";
export {
  getNotificationDeliverabilityStatus,
  isNotificationPermissionAvailable,
  type NotificationDeliverabilityInputs,
  type NotificationDeliverabilityStatus,
  type NotificationPermissionState,
  type PushTokenRegistrationState,
  type PushTokenResolutionState,
} from "./notification-deliverability";

export {
  useRegisterNotificationDevice,
  useRevokeNotificationDevice,
  type NotificationDevice,
  type RegisterNotificationDevicePayload,
} from "./hooks/useNotificationDevices";

export {
  useNotificationPreferences,
  useUpdateNotificationPreferences,
  type NotificationPreferencesData,
  type NotificationPreferencesPatch,
  type UpdateNotificationPreferencesPayload,
} from "./hooks/useNotificationPreferences";

export {
  countSupportedNotificationPreferences,
  isNotificationPreferenceEnabled,
  SUPPORTED_NOTIFICATION_PREFERENCE_FIELDS,
  type SupportedNotificationPreferenceField,
} from "./notification-preferences";

export {
  NOTIFICATION_TYPE_REGISTRY,
  NOTIFICATION_LINK_TYPES,
  SUPPORTED_NOTIFICATION_TYPES,
  UNKNOWN_NOTIFICATION_CONTRACT,
  getNotificationContract,
  getNotificationIdempotencyKey,
  getNotificationLinkType,
  parseNotificationData,
  type NotificationChannel,
  type NotificationData,
  type NotificationDestination,
  type NotificationExpiry,
  type NotificationLinkType,
  type NotificationPreferenceKey,
  type NotificationPrivacy,
  type NotificationProducerEvent,
  type NotificationPriority,
  type NotificationReadSemantics,
  type SupportedNotificationType,
} from "./notification-contract";

export {
  createNotificationFixtureSet,
  type NotificationFixture,
  type NotificationFixtureMode,
} from "./notification-fixtures";

export {
  getNotificationRowPresentation,
  type NotificationRowPresentation,
} from "./notification-presentation";

export {
  getNotificationNavAction,
  getNotificationNavActionForPayload,
} from "./notification-routing";
